module.exports = __webpack_public_path__ + "static/media/add_project.0fd872ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/add_project.svg
// module id = 148
// module chunks = 0